import React from 'react'
import {i18n} from 'common'
import {AdminPage, Tag, Icon} from '../components'

export default class Scopes extends AdminPage {
    onRenderIcon = (item, index) => (
        <td key={index}>
            {item.defaultScope && <Tag color="blue"><Icon src="flag" /></Tag>}
            {item.restricted && <Tag color="orange"><Icon src="ban" /></Tag>}
        </td>
    )

    config = {
        url: 'api/scopes',
        addButton: {title: i18n('manage-scopes.new'), url: '/scopes/new'},
        columns: [
            {type: 'render', title: '', className: 'table-50p', getter: this.onRenderIcon},
            {type: 'label', title: i18n('manage-scopes.fields.name'), className: 'table-200p', getter: ['value', 'icon']},
            {type: 'string', title: i18n('manage-scopes.fields.description'), getter: 'description'},
            {type: 'actions', allows: {'Edit': '/scopes/', 'Delete': 'api/scopes/'}, className: 'table-150p'}
        ]
    }
}
